/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */

import type {LoaderFunctionArgs} from 'react-router'
import {useLoaderData} from 'react-router-dom'

import LandingInstantOffer from './index.js'

import './styles/index.scss'

export async function loader({context, request}: LoaderFunctionArgs) {
  const {domain, i18n} = context
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`

  try {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: pathname})

    const [seoDataResult, sellVehicleConfigResult] = await Promise.allSettled([
      domain.get('get_seo_data_use_case').execute({culture: i18n.culture, pageName}),
      domain.get('get_sell_vehicle_config_form_use_case').execute({withAdditionalCarDataFields: true})
    ])

    const seoData = seoDataResult.status === 'fulfilled' ? seoDataResult.value?.[1] : null
    const sellVehicleConfigForm =
      sellVehicleConfigResult.status === 'fulfilled' ? sellVehicleConfigResult.value?.[1] : null

    return {
      pageName,
      h1: seoData?.h1 ?? '',
      helmet: seoData?.head || {},
      sellVehicleConfigForm
    }
  } catch (error) {
    console.error('[LandingInstantOffer] Loader error:', error)
    return {
      pageName: 'landing_instant_offer',
      h1: '',
      helmet: {},
      sellVehicleConfigForm: null
    }
  }
}

export function Component() {
  const data = useLoaderData()
  return <LandingInstantOffer {...data} />
}
